import { proxy } from 'valtio'

export const god_store = proxy({
  indicatorState: '盤整' as '偏多' | '盤整' | '偏空',
  volumeState: '正常' as '正常' | '量增' | '量縮',
})
